export default __webpack_public_path__ + "static/media/type-Q.5c4aacae.png";